import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { usePost } from "../../hooks/usePost";
import { CompassParagraph } from "../../components/common/styledComponents";
import { ElementContainer } from "../../components/containers/styledComponents";
import { Icon, IconContainer } from "../../components/visuals/styledComponents";
import { MESSAGES } from "../../messages";
import { GetControlPanelDataParams as ControlPanelFilters } from "../../types/controlPanelTypes";
import {
  darkGreen,
  compassLightGreen,
  compassBordeaux,
  compassLightRed,
  lightGreenBackground,
} from "../../styles";
import implicitTemperatureIconSuccess from "../../assets/svg/implicit_temperature_success.svg";
import implicitTemperatureIconFailure from "../../assets/svg/implicit_temperature_fail.svg";
import { PortfoliosTempData } from "../../models/controlPanelDataModel";
import {
  AlignmentTemperature,
  checkAlignment,
} from "../../components/visuals/PathwayProgressBar";

const ImplicitTemperatureIconContainer = styled.div<{ isSuccess: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
  padding: 5px;
  height: 100px;
  width: 60px;
  background-color: ${({ isSuccess }): string =>
    isSuccess ? lightGreenBackground : compassLightRed};
  margin-right: 15px;
  margin-left: 15px;
`;

const ImplicitTemperatureContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledCompassParagraph = styled(CompassParagraph)`
  overflow-y: auto;
  height: 60px;
  padding: 4px 0px;
  max-height: 100%;
`;

export const ImplicitTemperature = ({
  params,
}: ImplicitTemperatureProps): JSX.Element => {
  const [alignment, setAlignment] = useState<AlignmentTemperature>(
    AlignmentTemperature.ABOVE_THREE,
  );
  const { data: portfoliosTempData, sendData: getPortfoliosData } = usePost<
    PortfoliosTempData[],
    ControlPanelFilters
  >();

  useEffect(() => {
    getPortfoliosData("GET_PORTFOLIOS_TEMPERATURE", params);
  }, [params]);

  useEffect(() => {
    if (portfoliosTempData) {
      setAlignment(checkAlignment(portfoliosTempData[0]));
    }
  }, [portfoliosTempData]);

  const success =
    alignment === AlignmentTemperature.ONE_SEVEN_FIVE ||
    alignment === AlignmentTemperature.TWO;

  return (
    <>
      <ElementContainer ai="flex-start">
        <span>
          <CompassParagraph color={darkGreen} fontSize={14} bold={true}>
            Implied Temperature
          </CompassParagraph>
          <StyledCompassParagraph color="#8B909A" fontSize={12} mt={8}>
            {MESSAGES.PARIS_ALIGNED[success ? "SUCCESS" : "FAILURE"]}
          </StyledCompassParagraph>
        </span>
        <ImplicitTemperatureContainer>
          <ImplicitTemperatureIconContainer isSuccess={success}>
            <CompassParagraph
              color={success ? compassLightGreen : compassBordeaux}
              fontSize={14}
              mr={1}
              mb={10}
              mt={10}
              bold={true}
            >
              {alignment}
            </CompassParagraph>
            <IconContainer size={40} m={1} p={5}>
              <Icon
                src={
                  success
                    ? implicitTemperatureIconSuccess
                    : implicitTemperatureIconFailure
                }
              />
            </IconContainer>
          </ImplicitTemperatureIconContainer>
        </ImplicitTemperatureContainer>
      </ElementContainer>
    </>
  );
};

type ImplicitTemperatureProps = {
  params: ControlPanelFilters;
};
